import { render, staticRenderFns } from "./onboarding-bar.vue?vue&type=template&id=f2bc91aa&scoped=true&"
import script from "./onboarding-bar.vue?vue&type=script&lang=js&"
export * from "./onboarding-bar.vue?vue&type=script&lang=js&"
import style0 from "./onboarding-bar.vue?vue&type=style&index=0&id=f2bc91aa&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2bc91aa",
  null
  
)

export default component.exports